module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/lizard_BW-p-1600-325db94f657941931991b294ff4f4a58.jpg";